import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CollectionDto } from '../model/collection.model';
import { environment } from '../../environments/environment';
import { HttpClientHelper } from './http-client-helper.service';
import { firstValueFrom, map, tap } from 'rxjs';
import { ConsoleLoggerService } from './console-logger.service';
import { ToolLocationTypeListItem } from '../model/tool-location-type-list-item.model';
import { GridRequest } from '../model/grid-request.model';


@Injectable({
  providedIn: 'root'
})
export class LocationTypeService {

  constructor(private http: HttpClient,
              private httpClientHelper: HttpClientHelper,
              private log: ConsoleLoggerService) {
  }

  getToolLocationTypes() {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/toolLocationTypes`;
    const observable = this.http.get<CollectionDto<ToolLocationTypeListItem>>(url, { params: params })
      .pipe(tap(r => this.log.debug('toolLocationTypes: ', r)))
      .pipe(map(c => c.items))

    return firstValueFrom(observable)
  }

  getPagedToolLocationTypes(request: GridRequest) {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/toolLocationTypes/paged`;
    const observable = this.http.post<CollectionDto<ToolLocationTypeListItem>>(url, request, { params: params })
      .pipe(tap(r => this.log.debug('ToolLocationTypeListItems: ', r)));
    return firstValueFrom(observable);
  }

  saveLocationType(locationType: ToolLocationTypeListItem) {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/toolLocationTypes`;
    const observable = this.http.post<ToolLocationTypeListItem>(url, locationType, { params: params })
      .pipe(tap(r => this.log.debug('toolLocationTypes save response: ', r)));

    return firstValueFrom(observable);
  }

  updateLocationTypeStatus(id: number, active: boolean) {
    let params = this.httpClientHelper.createHttpParams();
    console.log('params1', params);
    params = params.append('active', active);
    console.log('params', params);

    let url = environment.apiUrl + `/toolLocationTypes/${id}/status`;
    const observable = this.http.put<boolean>(url, null, { params: params })
      .pipe(tap(r => this.log.debug('Location type updated: ', r)))

    return firstValueFrom(observable)
  }

}
